import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthorizeService } from 'src/app/api-authorization/authorize.service';
import { ApiUrls } from 'src/app/api-urls.constants';
import { AppPaths } from 'src/app/app-paths.constants';

@Component({
  selector: 'rek-dev-tools',
  templateUrl: './dev-tools.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DevToolsComponent {
  readonly AppPaths: AppPaths = AppPaths;

  constructor(private http: HttpClient, private authorize: AuthorizeService) { }

  onSVGInserted(svg): void {
    svg.classList.add('kt-svg-icon', 'kt-svg-icon--success', 'kt-svg-icon--lg');
  }

  deleteCurrentUserData(): void {
    if (confirm('Are you sure you want to delete the currently logged user\'s data?')) {
      this.http.delete(ApiUrls.Administration_DeleteCurrentUser)
        .subscribe({
          error: (err) => console.error(JSON.stringify(err)),
          complete: () => {
            alert('Data deleted successfully! You\'ll be redirected to the home page in a second.');
            this.authorize.signOut('delete user data');
          }
        });
    }
  }
}
